(function () {
  'use strict';

  angular.module('ringbaPortal').component('manageUserGroups', {
    controller: ManageUserGroupsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/user-groups/manage-user-groups.view.html'
  });

  function ManageUserGroupsController() {
    'ngInject';
  }
})();
